import React from 'react'
import { _weeks } from '../../utils/Constant'
import moment from 'moment';
import { validateTime } from '@mui/x-date-pickers/internals';

const WorkingHours = ({ formikProp }) => {
  return (
    <div className="col-md-12">
      <label>
        Working Hours <span className="text-danger">*</span>
      </label>
      <div className="table-responsive">
        <table
          className="table table-striped table-bordered admintable border-0 working-table"
          cellSpacing="0"
          cellPadding="0"
        >
          <tbody>
            <tr>
              <th>Sr.No.</th>
              <th>WeekDays</th>
              <th>Opening Time</th>
              <th>Closing Time</th>
              <th>On/Off</th>
            </tr>
          </tbody>
          <tbody>
            {_weeks.map((day, index) => (
              <tr key={index}>
                <td>{day.series}</td>
                <td>{day.name}</td>
                <td>
                  <input
                    type="time"
                    className="form-control border"
                    placeholder="Enter AM Time"
                    {...formikProp.getFieldProps(`workingHours.${index}.openAt`, {
                      validate: (value) => validateTime(value, formikProp.values?.workingHours?.[index]?.isDayEnable),
                    })}
                    onChange={(e) => {
                      const timeValue = moment(e.target.value, 'HH:mm').format('HH:mm');
                      formikProp.setFieldValue(`workingHours.${index}.openAt`, timeValue);
                    }}
                    disabled={!formikProp.values?.workingHours?.[index]?.isDayEnable}
                    value={formikProp.values?.workingHours?.[index]?.isDayEnable ? formikProp.values?.workingHours?.[index]?.openAt : ''}
                    min={"06:00"}
                    max={(formikProp.values?.workingHours?.[index]?.closeAt)}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    className="form-control border"
                    placeholder="Enter PM Time"
                    {...formikProp.getFieldProps(`workingHours.${index}.closeAt`)}
                    onChange={(e) => {
                      const timeValue = moment(e.target.value, 'HH:mm').format('HH:mm');
                      formikProp.setFieldValue(`workingHours.${index}.closeAt`, timeValue);
                    }}
                    disabled={!formikProp.values?.workingHours?.[index]?.isDayEnable}
                    value={formikProp.values?.workingHours?.[index]?.isDayEnable ? formikProp.values?.workingHours?.[index]?.closeAt : ''}
                  />
                </td>
                <td>
                  <input
									type="checkbox"
									key={day?.series}
									checked={formikProp.values?.workingHours?.[index]?.isDayEnable}
									onChange={(e) => {
										const toggleValues = e.target.checked
										formikProp.setFieldValue(`workingHours.${index}.isDayEnable`, toggleValues);
										if (toggleValues) {
											formikProp.setFieldValue(`workingHours.${index}.openAt`, '09:00');
											formikProp.setFieldValue(`workingHours.${index}.closeAt`, '18:30');
											formikProp.setFieldValue(`workingHours.${index}.day`, day.name);
										} else {
											formikProp.setFieldValue(`workingHours.${index}.openAt`, null);
											formikProp.setFieldValue(`workingHours.${index}.closeAt`, null);
											formikProp.setFieldValue(`workingHours.${index}.day`, null);
										}
									}}
								/>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default WorkingHours